import { type RenderElementProps, useFocused, useSelected } from 'slate-react';

import { cn } from '@/shadcn/lib/utils';

type Props = RenderElementProps;

export const MentionElement = ({ attributes, children, element }: Props) => {
  const selected = useSelected();
  const focused = useFocused();
  return (
    <span
      {...attributes}
      className={cn(
        'mx-px inline-block rounded-full bg-primary-deep/10 px-1.5 py-1 align-baseline text-primary-deep text-sm',
        selected && focused && 'outline outline-primary-deep'
      )}
      contentEditable={false}
    >
      {children}@{element.user.name}
    </span>
  );
};
